var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-text"},[_vm._v(" "+_vm._s(_vm.data.content || '暂无内容～')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }